import { DropdownItem } from '@/common/components';

export enum InputType {
  EMAIL = 'email',
  NUMBER = 'number',
  PHONE = 'phone',
  SELECT = 'select',
  TEXT = 'text',
}

export interface EntryForm {
  id?: string;
  name: string;
  options?: DropdownItem[];
  required?: boolean;
  section: string;
  target: string | number;
  type: string;
  isSensitive?: boolean;
}

export interface Options {
  id: string;
  value: string;
}

export interface ManualFormProps {
  data: EntryForm[];
  hasClean?: boolean;
  handleEdit?: (isEditing: boolean) => void;
  isLoading?: boolean;
  onSubmit?: (values: any) => void;
}

export enum SectionName {
  DETAILS = 'details',
  INFO = 'info',
  SERVICE = 'service',
}
